import { Box, Tab, Tabs } from '@mui/material';
import ConsultaCliente from './consulta';
import { SolicitudesDeBaja } from './solicitudesDeBaja';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import RolesGate from '../../../components/utils-components/permissions/rolesGate';
import { ROLES } from '../../../components/utils-components/permissions/permissions-map';
import { useRoleValidation } from '../../../hooks/useRoles';

const ClienteTabs = ({ pais }) => {
    const location = useLocation();
    const [selectedTab, setSelectedTab] = useState(location.state?.tab || 0);
    const { isLogistica } = useRoleValidation();

    const tabList = [
        {
            label: 'Lista Clientes',
            value: 0,
        },
        {
            label: 'Solicitudes de Baja',
            value: 1,
        },
    ];

    if (isLogistica) tabList.splice(1, 1);

    const hanldeChangeTab = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <Box sx={{ height: '100%', width: '100%' }} mt={1}>
            <Tabs value={selectedTab} onChange={hanldeChangeTab}>
                {tabList.map((item) => (
                    <Tab
                        sx={{ textTransform: 'none' }}
                        label={item.label}
                        value={item.value}
                    ></Tab>
                ))}
            </Tabs>
            {selectedTab === 0 && <ConsultaCliente pais={pais} />}
            {selectedTab === 1 && (
                <RolesGate
                    roles={[
                        ROLES.GERENCIA_EFFECTIVE,
                        ROLES.GERENCIA_WINNER,
                        ROLES.DIRECTOR_ADMINISTRATIVO,
                    ]}
                >
                    <SolicitudesDeBaja pais={pais} />
                </RolesGate>
            )}
        </Box>
    );
};

export default ClienteTabs;
